import { render, staticRenderFns } from "./Butacas.vue?vue&type=template&id=611c8a55&lang=pug&"
import script from "./Butacas.vue?vue&type=script&lang=js&"
export * from "./Butacas.vue?vue&type=script&lang=js&"
import style0 from "./Butacas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports